module.exports = __webpack_public_path__ + "static/media/scormIcon.e88ebce4.png";